module.exports = __webpack_public_path__ + "img/fa-regular-400.f5b89479.svg";